import { VariantProps, cva } from 'class-variance-authority';
import type { CommonProps } from '../../types';
import { twMerge } from 'tailwind-merge';
import { NavigationItem } from '../../atoms';
import type { NavigationItemData } from '@beat-venues/common-types';

import type { JSX } from 'react';

export interface ExtendedNavigationItemData extends NavigationItemData {
    isActive: boolean;
}

export interface NavigationListProps
    extends CommonProps,
        VariantProps<typeof NavigationListStyles> {
    items: ExtendedNavigationItemData[];
}

export const NavigationListStyles = cva(
    'flex overflow-x-scroll md:overflow-x-auto'
);

export const NavigationList = ({
    className,
    items,
    testId = 'navigation-list',
}: NavigationListProps): JSX.Element => {
    return (
        <ul
            className={twMerge(NavigationListStyles({ className }))}
            data-testid={testId}
        >
            {items.map(
                (item, index) =>
                    item.href && (
                        <NavigationItem
                            href={item.href}
                            label={item.label}
                            isActive={item.isActive}
                            key={item.href + index}
                        />
                    )
            )}
        </ul>
    );
};
